import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button as MuiButton } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import Theme from 'App.theme';
import Button from 'components/Button';
import FormControlLabel from 'components/FormControl/FormControlLabel';

// Container for the modal
export const SetModalContainer = styled.div`
  padding: 1rem;
`;

export const SetModalCenteredContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 2rem;
`;

// Button to select adding a tray or a device
export const SetModalButton = withStyles({
  root: { width: '20rem', height: '15rem', fontSize: '1rem', fontFamily: Theme.font },
})(MuiButton);

// Link Button styling
export const SetModalLinkButton = styled(Link)`
  text-decoration: none;
  color: inherit;
  max-width: 12rem;
  width: 100%;
`;

// Edit Button styling
export const SetModalEditConfirmButton = styled(Button)`
  max-width: 12rem;
  width: 100%;
`;

export const SetModalEditCancelButton = styled(Button)`
  max-width: 12rem;
  width: 100%;
`;

// Container for content within the modal button
export const SetModalButtonContent = styled.div`
  font-size: 3rem;
`;

// Text within the model button content
export const SetModalButtonText = styled.h4`
  font-size: 1rem;
  margin: 0;
`;

// Simple divider to separate the modal buttons
export const SetModalDivider = styled.div`
  border-left: 2px solid ${Theme.greys.GREY0};
  margin: 1rem;
`;

// Container for the header within a modal
export const SetModalHeader = styled.h2`
  margin: 0.5rem auto;
  margin-bottom: 2rem;
`;

// Container for the submission button within a modal
export const SetModalButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  gap: 1rem;
`;

// Container for space-between buttons within a modal
export const SetModalSpacedButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 2rem;
  gap: 1rem;
  justify-content: space-around;
`;

// Wide modal
export const SetModalWide = styled(SetModalContainer)`
  min-width: 50rem;
`;

// Normal modal
export const SetModalMedium = styled(SetModalContainer)`
  min-width: 40rem;
`;

// Container for list buttons in the modal
export const PartModalButtonContainer = styled.div`
  width: 100%;
  margin-bottom: 0.5rem;
`;

// Changes the display of the search results depending on the loading context
interface PartModalSearchProps {
  $loading: boolean;
}

// Container for part search results in the modal
export const PartModalSearch = styled.div<PartModalSearchProps>`
  overflow: auto;
  margin-top: 1rem;
  min-height: 4rem;
  max-height: 30rem;

  ${props =>
    props.$loading &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
    `}
`;

// Container for part fields in the modal
export const PartModalButton = styled(Button)`
  margin-top: 16px;
`;

export const CenteredCheckbox = styled(FormControlLabel)`
  width: 100%;
  justify-content: center;
`;
